import React, { useEffect, useState } from "react";
import filterimg from "../../assets/images/filter.svg";
import usePilotBids from "hooks/usePilotBids";
import { Row, Col } from "react-bootstrap";
import BidCard from "components/Dashboard/BidCard";
import Negotiation from "components/Modals/FormPopup/Negotiation";
import { jobService } from "services/job.service";
import Loader from "components/Loader";
import { toast } from "react-toastify";
import FiltersPop from "components/Modals/FormPopup/FiltersPop";

const MyBids = () => {
  const[show,setShow]=useState(false)
  const [data, setData] = useState('')
const handleShow =()=>{
  setShow(true);
}

  const [dataLength, setDataLength] = useState({
    skip: 0,
    limit: 9
  })
  const [selectedBidId, setSelectedBidId] = useState(null);
  const [showNegotiate, setShowNegotiate] = useState(false);
  const { bidsObj, isLoading } = usePilotBids(dataLength);
  const [loading, setLoading] = useState(false);
  const [bidsData, setBidsData] = useState({})
  const { totalBids, bids } = bidsData;

  useEffect(() => {
    if (isLoading === false) {
      setBidsData(bidsObj)
    }
  }, [isLoading])

  const onShowNegotiate = (id) => {
    setShowNegotiate(true);
    setSelectedBidId(id)
  }

  const handleClose = () => {
    setShowNegotiate(false);
    setShow(false)
  }

  const handleAccept = async (id) => {
    const payload = {
      jobBidId: id,
      status: 'Accept'
    }
    try {
      setLoading(true);
      const response = await jobService.updateBidStatus(payload);
      const newData = bidsData.bids.map(item => {
        if (item._id === response.data.data.bid._id) {
          return {
            ...item,
            ...response.data.data.bid
          }
        }
        return item;
      })
      setTimeout(() => {
        setBidsData({ bids: newData, totalBids: newData.length });
        toast.success('Job accepted successfully', { autoClose: 1000 });
      }, 2000)
    } catch (err) {
      console.log(err);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000)
    }
  }

  const handleViewMore = () => {
    const data = dataLength;
    setDataLength({
      ...data,
      limit: data?.limit + 9
    })
  }
  
  return (
    <div className="container-box">
      <Loader loading={loading} />
      <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
        <div className="d-flex">
          <h2>My Bids</h2>
          <span className="bedge-green">
            {totalBids}
          </span>
        </div>
        {/* <div className="filterdiv">
          <img src={filterimg} alt="" />
        </div> */}
   
      </div>
      <div className="outer-white">
        <div className="my-job-tabs my-job-bids-tabs">
          <div>
            <Row>
              {bids?.length > 0 && bids?.map(item => {
                return (
                  <Col xl={4} lg={6} key={item?._id}>
                    <BidCard
                      item={item}
                      onShowNegotiate={onShowNegotiate}
                      handleAccept={handleAccept}
                    />
                  </Col>
                )
              })}
            </Row>
          </div>
        </div>
        {bids?.length < totalBids && <div className="d-flex flex-wrap gap-2 justify-content-center">
          <button className=" blue-btnnn text-white" onClick={handleViewMore}>
            View More
          </button>
        </div>}
      </div>
      <Negotiation
        show={showNegotiate}
        handleClose={handleClose}
        selectedBidId={selectedBidId}
        bidsData={bidsData}
        setBidsData={setBidsData}
      />
    </div>
  );
};

export default MyBids;
